// extracted by mini-css-extract-plugin
export default {"container":"ModalCMS_container__OLcPe","form":"ModalCMS_form__Lz9lH","wrapperCard":"ModalCMS_wrapperCard__gS7wp","box":"ModalCMS_box__e6-1P"};